import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Inject, Injectable, NgZone } from '@angular/core';

import { NotificationService } from "./notification.service";
import { NotificationType } from "../model/notification-type.model";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})
export class ErrorsHandlerService implements ErrorHandler {

  constructor(@Inject(NgZone) private ngZone: NgZone,
              @Inject(NgxSpinnerService) private readonly spinnerService: NgxSpinnerService,
              @Inject(NotificationService) private readonly notification: NotificationService) { }

  /**
  * Metodo que sobrescreve e implementa o metodo default de captura de erros do angular
  * @param error
  */
  handleError(error: any | HttpErrorResponse) {
    //if (error.rejection !== undefined) {
        if (error instanceof HttpErrorResponse) {
            return this.ngZone.run(() => {
               console.log(this.getError(error.status, error.message));
               this.notification.sendNotification(this.getError(error.status, error.message));
            });
        }
    //}
  }

  /**
  * Obtem a notificacao conforme o status do http
  * @param code status do erro
  */
  private getError(code: number, message: string): any {
    switch (code) {
        case 0:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro Interno do Servidor',
                message: 'O sistema se comportou de forma inesperada. Aguarde e tente novamente mais tarde ou contate o suporte.',
                type: NotificationType.ERROR,
                time: 5000
            };
        case 200:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Solicitação realizada com sucesso',
                message: 'A requisição foi processada com êxito.',
                type: NotificationType.SUCCESS,
                time: 5000
            };
        case 201:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Cadastro realizado com sucesso',
                message: 'A solicitação foi processada com êxito.',
                type: NotificationType.SUCCESS,
                time: 5000
            };
        case 400:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro Requisição Inválida',
                message: 'Os dados da requisição são inválidos.',
                type: NotificationType.ERROR,
                time: 5000
            };
        case 404:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro Requisição Inválida',
                message: 'Os dados da requisição não foram encontrados na base de dados.',
                type: NotificationType.ERROR,
                time: 5000
            };
        case 412:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro ao efetuar cadastro',
                message: message,
                type: NotificationType.WARNING,
                time: 5000
            };
        case 500:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro Interno do Servidor',
                message: 'Falha ao processar ao processar a solicitação.',
                type: NotificationType.ERROR,
                time: 5000
            };
        case 502:
            setTimeout(() => {
                this.spinnerService.hide();
            }, 500);
            return {
                title: 'Erro Interno do Servidor',
                message: 'A requisição foi processada com êxito. Aguarde e tente novamente mais tarde ou contate o suporte.',
                type: NotificationType.ERROR,
                time: 5000
            };
        }
    }

}
